export enum RegionTypes {
  Any = 0,
  Branch,
  Partner,
  PVZ,
  DeliveryRegions,
}

export interface TypeRegion {
  ID: number;
  REGION_CODE: string;
  REGION: string;
  NAME: string;
  CODE: string;
  SNAME: string;
  REGION_TYPE: RegionTypes;
  COMMENT: null;
  PHONE: string;
  ORDER_PHONE: string;
  FEDERAL_PHONE: string;
  EMAIL: string;
  ORDER_EMAIL: string;
  REGSITE: null;
  SUBDOMAIN: string;
  COMPANY_NAME: string;
  ORGANIZATION: string;
  PARUS_DEPARTMENT: string;
  PREPOSITIONAL: string;
  YANDEX_MARKET: string;
  IBLOCK_ID: number;
  SORT: number;
  ACTIVE: number;
  GOOGLE_MERCHANT: null;
  UTC: number;
  FIASID: string;
  mapZoom: number;
}
